export default __webpack_public_path__ + "static/media/TTSI_Claims_Form.8f6134f9.pdf";